var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 8.01005H8.81006V6.00005C8.81006 5.21005 7.95006 4.74005 7.28006 5.15005L2.47006 8.16005C1.84006 8.55005 1.84006 9.46005 2.47006 9.86005L7.28006 12.8701C7.95006 13.2901 8.81006 12.8101 8.81006 12.0201V10.0101H16.5001C18.4301 10.0101 20.0001 11.5801 20.0001 13.5101C20.0001 15.4401 18.4301 17.0101 16.5001 17.0101H7.24006C6.69006 17.0101 6.24006 17.4601 6.24006 18.0101C6.24006 18.5601 6.69006 19.0101 7.24006 19.0101H16.5001C19.5301 19.0101 22.0001 16.5401 22.0001 13.5101C22.0001 10.4801 19.5301 8.01005 16.5001 8.01005Z",
    fill: "#383947"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.6a1dde660733d1fa775bc0f0d89e4ff0.svg";
export { ForwardRef as ReactComponent };